<template>
  <div class="phoneBind-container">
    <el-steps :active="active" finish-status="success" simple>
      <el-step title="验证手机号码"></el-step>
      <el-step title="更换手机号码"></el-step>
    </el-steps>
    <div style="margin: 0 auto;width: 60%;padding-top: 40px;">
    <el-form ref="bindForm" :model="bindForm" :rules="rulesBind"  label-position="right" label-width="75px" size="medium">
      <el-form-item label="手机号码" prop="oldusername" v-show="active==0">
        <el-input v-model="bindForm.oldusername" style="width: 270px" placeholder="请输入原登录手机号码" maxlength="11" minlength="11"></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="code" v-show="active==0" >
        <el-input v-model="bindForm.code" style="width: 150px" placeholder="请输入短信验证码" maxlength="6" minlength="6"></el-input>
        <el-button :disabled="isDisabledCode" :loading="isCodeLoading" @click="getCode(0)">{{codeBtn}}</el-button>
      </el-form-item>
      <el-form-item label="更换手机" prop="username" v-show="active==1">
        <el-input v-model="bindForm.username" style="width: 270px" placeholder="请输入新的手机号码" maxlength="11" minlength="11"></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="new_code" v-show="active==1" >
        <el-input v-model="bindForm.new_code" style="width: 150px" placeholder="请输入短信验证码" maxlength="6" minlength="6"></el-input>
        <el-button :disabled="isDisabledCode" :loading="isCodeLoading" @click="getCode(1)">{{codeBtn}}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button :loading="isLoading" type="primary" @click="sub()">{{nextBtn}}</el-button>
<!--        <el-button @click="Close()">取消</el-button>-->
      </el-form-item>
    </el-form>
    </div>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { validatePhoneNumber } from '@/utils/validate'
import { getSMSCode, checkCode, ChangePhoneNumbe } from '@/api/pub'

export default {
  computed: {
    user: getUser
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        if (this.tel === value) {
          callback()
        } else {
          callback(new Error('此手机号与登录手机号不匹配'))
        }
      }
    }
    const validateCode = (rule, value, callback) => {
      if (rule.required) {
        if (value.length !== 6) {
          callback(new Error('请输入6位短信验证码'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const validateNewUsername = (rule, value, callback) => {
      if (rule.required) {
        if (!validatePhoneNumber(value)) {
          callback(new Error('请输入正确的手机号码'))
        } else {
          if (this.tel === value) {
            callback(new Error('此手机号不能跟原手机号码一致'))
          } else {
            callback()
          }
        }
      } else {
        callback()
      }
    }
    const validateNewCode = (rule, value, callback) => {
      if (rule.required) {
        if (value.length !== 6) {
          callback(new Error('请输入6位短信验证码'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      active: 0,
      isLoading: false,
      isDisabledCode: false,
      isCodeLoading: false,
      codeBtn: '获取验证码',
      codeTimer: '',
      sounds: 60,
      nextBtn: '下一步',
      tel: '',
      uptel: '',
      bindForm: {
        oldusername: '',
        msg_id: '',
        code: '',
        username: '',
        new_msg_id: '',
        new_code: ''
      },
      rulesBind: {
        oldusername: [{ required: true, trigger: 'change', validator: validateUsername }],
        code: [{ required: true, trigger: 'change', validator: validateCode }],
        username: [{ required: false, trigger: 'change', validator: validateNewUsername }],
        new_code: [{ required: false, trigger: 'change', validator: validateNewCode }]
      }
    }
  },
  created() {
    if (this.user.rank === 0) {
      this.tel = this.user.dUsername
    } else {
      this.tel = this.user.username
    }
  },
  methods: {
    Close() {
      this.$emit('closePhoneBind', this.tel)
    },
    sub() {
      if (this.active === 0) {
        this.$refs['bindForm'].validate((valid) => {
          if (valid) {
            if (this.bindForm.msg_id.length > 0) {
              this.isLoading = true
              checkCode({ msg_id: this.bindForm.msg_id, code: this.bindForm.code }).then(response => {
                this.isLoading = false
                clearInterval(this.codeTimer)
                this.codeBtn = '获取验证码'
                this.isDisabledCode = false
                this.sounds = 60
                this.active = 1
                this.nextBtn = '更换绑定'
                this.rulesBind.username[0].required = true
                this.rulesBind.new_code[0].required = true
                this.$refs['bindForm'].clearValidate()
              }).catch(() => {
                this.isLoading = false
              })
            } else {
              this.$message({
                type: 'error',
                message: '验证码错误'
              })
            }
          } else {
            return false
          }
        })
      } else {
        this.$refs['bindForm'].validate((valid) => {
          if (valid) {
            if (this.uptel === this.bindForm.username) {
              this.isLoading = true
              let _userid = null
              if (this.user.rank === 0) {
                _userid = this.user.dUserid
              } else {
                _userid = this.user.userid
              }
              const data = {
                userid: _userid,
                role: this.user.rank,
                username: this.bindForm.username,
                msg_id: this.bindForm.new_msg_id,
                code: this.bindForm.new_code
              }
              ChangePhoneNumbe(data).then(response => {
                this.isLoading = false
                this.tel = this.bindForm.username
                if (this.user.rank === 0) {
                  this.user.dUsername = this.bindForm.username
                } else {
                  this.user.username = this.bindForm.username
                }
                sessionStorage.setItem('ElichainUser', JSON.stringify(this.user))
                clearInterval(this.codeTimer)
                this.codeBtn = '获取验证码'
                this.isDisabledCode = false
                this.sounds = 60
                this.active = 0
                this.nextBtn = '更换绑定'
                this.rulesBind.username[0].required = false
                this.rulesBind.new_code[0].required = false
                this.$refs['bindForm'].resetFields()
                this.Close()
                this.$confirm('建议你重新登录一下，免得让我为难好吗?', '手机绑定更换成功', {
                  confirmButtonText: '去登录',
                  cancelButtonText: '关闭',
                  type: 'success'
                }).then(() => {
                  this.$store.dispatch('user/logout')
                  this.$router.push(`/login`)
                }).catch(() => {
                })
              }).catch(() => {
                this.isLoading = false
              })
            } else {
              this.$message({
                type: 'error',
                message: '验证手机号码不一致，请重新获取验证码'
              })
              return false
            }
          } else {
            return false
          }
        })
      }
    },
    getCode(isnext) {
      let isok = false
      if (isnext === 0) {
        if (validatePhoneNumber(this.bindForm.oldusername)) {
          if (this.tel === this.bindForm.oldusername) {
            isok = true
          }
        }
      } else {
        if (validatePhoneNumber(this.bindForm.username)) {
          if (this.bindForm.username !== this.tel) {
            isok = true
          }
        }
      }
      if (isok) {
        if (!this.isDisabledCode) {
          if (this.sounds === 60) {
            this.isCodeLoading = true
            let data = this.bindForm.oldusername
            if (isnext === 1) {
              data = this.bindForm.username
            }
            getSMSCode(data).then(response => {
              this.codeTimer = setInterval(this.countdown, 1000)
              this.isCodeLoading = false
              this.isDisabledCode = true
              if (isnext === 0) {
                this.bindForm.msg_id = response.data.msg_id
              } else {
                this.uptel = this.bindForm.username
                this.bindForm.new_msg_id = response.data.msg_id
              }
            }).catch(() => {
              this.isCodeLoading = false
            })
          } else {
            this.isDisabledCode = true
          }
        }
      } else {
        return false
      }
    },
    countdown() {
      this.sounds--
      if (this.sounds === 0) {
        clearInterval(this.codeTimer)
        this.codeBtn = '获取验证码'
        this.isDisabledCode = false
        this.sounds = 60
      } else {
        this.codeBtn = '重新获取 ' + this.sounds
      }
    }
  }
}
</script>

<style scoped>
.phoneBind-container{

}
</style>
